import axios from 'axios';
import util from '../common/util';
import { normal } from './defaultSpacing';
const titleSizeMap = {
    template4: 25,
    template2: 24
};

export async function loadModuleConfig(name, theme, modulesMap, globalData) {
    let component,
        ps = [],
        moduleMap = modulesMap[name] || {};
    if ((component = moduleMap[theme])) {
        ps.push(component());
    } else {
        let moduleBase = await getModuleBase(name, theme),
            base =
                (moduleBase.data &&
                    moduleBase.data.theme &&
                    moduleBase.data.theme.base) ||
                null;

        if (base && (component = moduleMap[base])) {
            ps.push(component(), getModuleStyle(name, theme));
        } else if ((component = moduleMap.config)) {
            ps.push(component(), getModuleStyle(name, theme));
        } else {
            ps.push(getModuleTemplate(name, theme));
        }
    }
    return Promise.all(ps).then(([component, componentStyle]) => {
        return [
            {
                data() {
                    return {
                        fullColumn: false,
                        ...normal,
                        mobileNoMargin: false,
                        titleSize: titleSizeMap[globalData.template] || 18
                    };
                }
            },
            component.default || component,
            componentStyle || {}
        ];
    });
}
if (process.env.NODE_ENV === 'development') window.textHtmlRatio = {};
export default function (
    components,
    moduleName,
    name,
    theme,
    modulesMap,
    renderStatus = 3,
    globalData = {}
) {
    let Module = components[moduleName];
    if (!Module || renderStatus !== 3) {
        return loadModuleConfig(name, theme, modulesMap, globalData).then(
            ModuleConfig => {
                const componentOptions = {
                    mixins: ModuleConfig,
                    props: ['id'],
                    data: function () {
                        return this.$root.moduleData.find(m => m.id === this.id)
                            .data;
                    },
                    mounted() {
                        let moduleData = this.$root.moduleData,
                            idx = util.indexOf(moduleData, this.id, 'id');
                        moduleData[idx].moduleMounted = true;
                        if (this.$el && this.$el.nodeName !== '#comment') {
                            moduleData[idx].moduleRender = true;
                            this.$root.$emit('module-mounted', this);
                        }
                        if (process.env.NODE_ENV === 'development') {
                            setTimeout(() => {
                                window.textHtmlRatio[moduleName] = (
                                    ((this.$el.textContent &&
                                        this.$el.textContent.length) ||
                                        0) /
                                    ((this.$el.outerHTML &&
                                        this.$el.outerHTML.length) ||
                                        1)
                                ).toFixed(3);
                            }, 3000);
                        }
                    },
                    beforeCreate() {
                        const opts = this.$root.moduleData.find(
                            m => m.id === this.$options.propsData.id
                        );
                        if (opts.data.$storeName) {
                            this.$storeName = opts.data.$storeName;
                        }
                        if (opts.blockOb) {
                            this.$options.blockOb = opts.blockOb;
                        }
                    },
                    updated() {
                        //$emit 'module-mounted' only once normally
                        //component may emit 'module-mounted' several times when div(node that is not comment)=>comment, for example waiting then find nothing
                        let moduleData = this.$root.moduleData,
                            idx = util.indexOf(moduleData, this.id, 'id');
                        if (!this.$el) {
                            return;
                        }
                        if (this.$el.nodeName == '#comment') {
                            moduleData[idx].moduleRender &&
                                this.$root.$emit('module-mounted', this);
                            return (moduleData[idx].moduleRender = false);
                        }
                        if (moduleData[idx].moduleRender) {
                            return;
                        }
                        (moduleData[idx].moduleRender = true) &&
                            this.$root.$emit('module-mounted', this);
                    }
                };
                if (renderStatus === 3) {
                    components[moduleName] = componentOptions;
                }
                return componentOptions;
            }
        );
    } else {
        return new Promise(res => {
            res(Module);
        });
    }
}

function getModuleBase(name, theme) {
    return axios.post('/api-graphql', {
        query: `{theme(name:"${name}",theme:"${theme}"){base}}`
    });
}

function getModuleStyle(name, theme) {
    return axios
        .post('/api-graphql', {
            query: `{theme(name:"${name}",theme:"${theme}"){code}}`
        })
        .then(res => {
            let code = res.data && res.data.theme && res.data.theme.code;
            if (!code) {
                console.error(res, name, theme);
                return Promise.reject('no data');
            }
            if (typeof code === 'string') {
                code = JSON.parse(code);
            }
            if (!util.inNode()) {
                util.addStyle(code.css, false);
            }

            return {
                mixins: [
                    new Function('return ' + code.template)(),
                    code.js ? new Function(code.js)() : {}
                ]
            };
        });
}

function getModuleTemplate(name, theme) {
    return axios
        .post('/api-graphql', {
            query: `{module(name:"${name}"){js}theme(name:"${name}",theme:"${theme}"){code}}`
        })
        .then(res => {
            let code = res.data && res.data.theme && res.data.theme.code;
            let js = res.data && res.data.module && res.data.module.js;
            if (!code || !js) {
                return Promise.reject('no data');
            }
            if (typeof code === 'string') {
                code = JSON.parse(code);
            }
            if (!util.inNode()) {
                util.addStyle(code.css, false);
            }
            return {
                mixins: [
                    new Function(js)(),
                    code.js ? new Function(code.js)() : {},
                    new Function('return ' + code.template)()
                ]
            };
        });
}
